export class TemplateEmail {
    public id: number;
    public name: string;
    public asunt: string;
    public body: string;
    public variable: string;
    public active: boolean;
    constructor () {}
}
